import React, { useState } from "react";
import "./SyrosEvNavbar.css";

const defaultMenuItems = [
  { name: "Exterior", section: "exterior" },
  { name: "Interior", section: "interior" },
  { name: "Safety", section: "safety" },
  { name: "ADAS", section: "adas" },
  { name: "Comfort & Convenience", section: "comfort" },
  { name: "Connectivity", section: "connectivity" },
];

export default function SyrosEvNavbar({
  scrollToSection,
  brochureLink,
  onBookNow,
  title = "The Kia Syros EV",
  menuItems = defaultMenuItems,
}) {
  const [open, setOpen] = useState(false);

  const handleClick = (section) => {
    if (scrollToSection) scrollToSection(section);
    setOpen(false);
  };

  const handleDownloadBrochure = () => {
    window.open(brochureLink, "_blank");
  };

  return (
    <div className="syrosev-navbar">
      <h1 className="syrosev-logo">{title}</h1>

      <div className="syrosev-menu">
        {menuItems.map((item) => (
          <button
            key={item.name}
            onClick={() => handleClick(item.section)}
            className="syrosev-menu-item"
          >
            {item.name}
          </button>
        ))}
      </div>

      <div className="syrosev-actions">
        <button
          className="syrosev-action-btn"
          onClick={() => handleClick("showInterest")}
        >
          Show Interest
        </button>
        <button className="syrosev-action-btn" onClick={handleDownloadBrochure}>
          Download Brochure
        </button>
        <button
          className="syrosev-action-btn syrosev-action-btn--filled"
          onClick={onBookNow}
        >
          Book Now
        </button>
      </div>

      <div className="syrosev-mobile-icon" onClick={() => setOpen(!open)}>
        More {open ? "▲" : "▼"}
      </div>

      {open && (
        <div className="syrosev-mobile-dropdown">
          {menuItems.map((item) => (
            <button
              key={item.name}
              onClick={() => handleClick(item.section)}
              className="syrosev-mobile-dropdown-item"
            >
              {item.name}
            </button>
          ))}
          <button
            className="syrosev-mobile-dropdown-item"
            onClick={() => handleClick("showInterest")}
          >
            Show Interest
          </button>
          <button className="syrosev-mobile-dropdown-item" onClick={handleDownloadBrochure}>
            Download Brochure
          </button>
        </div>
      )}
    </div>
  );
}
